function decodeUserIdFromToken(accessToken) {
    if (!accessToken || typeof accessToken !== 'string') return null;
    try {
        const parts = accessToken.split('.');
        if (parts.length !== 3) return null;
        const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const decoded = JSON.parse(atob(payload));
        return decoded.user_id != null ? decoded.user_id : null;
    } catch (e) {
        return null;
    }
}

let authServices = {
    authHeaders() {
        const user = this.storedUser();

        if (user && user.accessToken) {
          return { 'x-access-token': user.accessToken };
        } else {
          return {};
        }
    },

    // Stored session, guarded against corrupt localStorage JSON.
    storedUser() {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch (e) {
            return null;
        }
    },

    userIdFromToken(accessToken) {
        return decodeUserIdFromToken(accessToken);
    },

    // Current user id: the stored userId when present, otherwise the JWT claim.
    currentUserId() {
        const user = this.storedUser();
        if (!user) return null;
        if (user.userId != null) return user.userId;
        return decodeUserIdFromToken(user.accessToken);
    }

}

module.exports = authServices;
